import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { TimeObjectionSection } from '../components/TimeObjectionSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCloseSection } from '../components/FinalCloseSection';
import { SectionDivider } from '../components/SectionDivider';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const META_PIXEL_ID = '874982625170304';
export function Home() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    window.fbq = n;
    window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="w-full min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden" data-id="element-166">
      <HeroSection data-id="element-167" />
      <SectionDivider data-id="element-168" />
      <ProblemSection data-id="element-169" />
      <SectionDivider data-id="element-170" />
      <SolutionSection data-id="element-171" />
      <SectionDivider data-id="element-172" />
      <WhatsInsideSection data-id="element-173" />
      <SectionDivider data-id="element-174" />
      <ValueStackSection data-id="element-175" />
      <SectionDivider data-id="element-176" />
      <TimeObjectionSection data-id="element-177" />
      <SectionDivider data-id="element-178" />
      <GuaranteeSection data-id="element-179" />
      <SectionDivider data-id="element-180" />
      <FAQSection data-id="element-181" />
      <SectionDivider data-id="element-182" />
      <FinalCloseSection data-id="element-183" />

      <footer className="border-t border-[#1a1a1a] py-8 text-center" data-id="element-184">
        <p className="text-gray-600 text-xs tracking-wider" data-id="element-185">
          © 2026 Nano-Creative Labs. Todos los derechos reservados.
        </p>
      </footer>

      <RecentPurchaseToast data-id="element-186" />
    </div>;
}